import { Action, createReducer, on } from '@ngrx/store';
import { EquipmentProduct, EquipmentFilter, EquipmentTapInformation } from 'src/app/models/equipment.model';
import * as fromStore from '../fromEquipment.barrel';

export const equipmentFeatureKey = 'equipment';
export enum Loader {
  loadingTapSizes,
  loadingResults,
  loadingTappingMachines
}

export interface State {
  loaders: Loader[];
  hotTapApplications: string[];
  tappingMachines: EquipmentProduct[];
  tapSizes: number[];

  activeFilter?: EquipmentFilter;
  filterResult: EquipmentTapInformation[];
}

export const initialState: State = {
  loaders: [],
  hotTapApplications: [
    'Standard Hot Tap',
    'STOPPLE® Hot Tap',
    'SHORTSTOPP® Hot Tap'
  ],
  tapSizes: [],
  tappingMachines: [],
  filterResult: []
};

export const reducer = createReducer(
  initialState,
  on(fromStore.loadTapSizes, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loader.loadingTapSizes)
  })),
  on(fromStore.loadTapSizesSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(l => l !== Loader.loadingTapSizes),
    tapSizes: action.res
  })),
  on(fromStore.loadTapSizesFail, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(l => l !== Loader.loadingTapSizes)
  })),
  on(fromStore.loadTappingMachines, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loader.loadingTappingMachines)
  })),
  on(fromStore.loadTappingMachinesSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(l => l !== Loader.loadingTappingMachines),
    tappingMachines: action.res
  })),
  on(fromStore.loadTappingMachinesFail, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(l => l !== Loader.loadingTappingMachines)
  })),
  on(fromStore.updateFilter, (state, action) => ({
    ...state,
    activeFilter: {
      ...state.activeFilter,
      ...(action.obj as EquipmentFilter)
    }
  })),
  on(fromStore.loadEquipmentTapInformation, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loader.loadingResults)
  })),
  on(fromStore.loadEquipmentTapInformationSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(l => l !== Loader.loadingResults),
    filterResult: action.result.value || []
  }))
);
